export default "__VITE_IMAGE_ASSET__06e53b92__";